<template lang="jade" src="../_partials/input.jade"></template>
<script>
  import _ from 'lodash'
  import inputs from '../_shared/traits'

  export default {
    mixins: [inputs],
    data () {
      return {
        formInput: '',
        keymap: ['Delete', 'Backspace', 'Enter', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown']
      }
    },
    props: {
      fdata: {
        type: Object,
        coerce: x => {
          let mask = _.filter(x.validation, xs => xs.rule.split(':')[0] === 'mask')
          let validation = _.filter(x.validation, xs => xs.rule.split(':')[0] !== 'mask')
          return Object.assign({}, x, {mask, validation})
        },
        required: true
      }
    },
    methods: {
      mask (e) {
        let key = e.key
        if (this.fdata.mask.length === 0 || _.includes(this.keymap, key)) return true
        if (e.ctrlKey || e.metaKey) return true
        let pattern = this.pattern(this.fdata.mask[0].rule.split(':')[1])
        let regex = new RegExp(pattern)
        if (!regex.test(key)) {
          e.preventDefault()
          return false
        }
        return true
      },
      pattern (mask) {
        let flags = mask.replace(/.*\/([gimy]*)$/, '$1')
        return mask.replace(new RegExp('^/(.*?)/' + flags + '$'), '$1')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// text.vue?0c32d470